import apiService from "../services/api.service";

export const referralEvent = "applied-referral-change";
export const getAppliedReferral = () => localStorage.getItem("referral_code") || "";

export function saveAppliedReferral(code, name = "") {
  if (code) {
    localStorage.setItem("referral_code", code);
    localStorage.setItem("referral_name", name);
  } else {
    localStorage.removeItem("referral_code");
    localStorage.removeItem("referral_name");
  }
  window.dispatchEvent(new Event(referralEvent));
}

export function ownReferralCode(profile) {
  const user = profile?.user || profile || {};
  return String(profile?.referral?.code || profile?.referral_info?.code ||
    user?.referral?.code || user?.referral_info?.code ||
    user?.referral_code?.code || user?.referral_code || profile?.referral_code?.code || profile?.referral_code || "");
}

export async function validateAppliedReferral(code) {
  if (!code || !localStorage.getItem("token")) return code;
  const response = await apiService.getProfile();
  const own = ownReferralCode(response.data);
  if (own && own.toLowerCase() === code.toLowerCase()) {
    if (getAppliedReferral() === code) saveAppliedReferral("");
    throw new Error("You cannot use your own referral code.");
  }
  return getAppliedReferral() === code ? code : "";
}
